import { WindDirectionSettings } from '@mono/types/src/weather-widgets/wind-direction-settings';
import { SpaceGeometryTypePoint } from '@metservicedev/platforms-services-interface/src/model/Widgetblock';

export const defaultWindDirectionSettings: WindDirectionSettings = {
    title: 'Wind Direction (°)',
    space: {
        type: SpaceGeometryTypePoint,
        coordinates: [173, -40],
    },
    displayTable: true,
};
